export default {"src":"/_next/static/media/outer-1.2452e73f.svg","height":74,"width":74,"blurWidth":0,"blurHeight":0};